import React from 'react';
import Link from '../../components/LinkWithCountry/LinkWithCountry';
import endpoints from '../../shared/constants/endpoints';
import cookieMoon from './imgs/unavailable-cookie.svg';
import bakeryIcon from './imgs/MapPin.svg';
import menuIcon from './imgs/Cookie.svg';
import helpIcon from './imgs/ChatTeardrop.svg';

const BrandRefreshNotFound = () => (
  <main data-region="secondary-page" data-page="NotFound">
    <section data-part="unavailable-panel" aria-labelledby="unavailable-title">
      <img src={cookieMoon} alt="" />
      <h1 id="unavailable-title">This page is currently unavailable</h1>
      <p>The link may be broken or the page may have moved. Please try again later, or contact us for help.</p>
      <div data-part="unavailable-actions">
        <Link to="/contact">Contact us</Link>
        <Link to="/">Back to Home</Link>
      </div>
    </section>
    <nav data-part="unavailable-shortcuts" aria-label="Other ways to find what you need">
      <h2>Looking for something else?</h2>
      <div>
        <Link to={endpoints.locations}>
          <img src={bakeryIcon} alt="" />
          Find a bakery
        </Link>
        <Link to="/menu">
          <img src={menuIcon} alt="" />
          Explore the Menu
        </Link>
        <Link to="/contact">
          <img src={helpIcon} alt="" />
          Get Help
        </Link>
      </div>
    </nav>
  </main>
);

export default BrandRefreshNotFound;
